import {
  Modal,
  Button,
  notification,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  Image,
  Input,
} from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../../store/hooks";
import userSelectors from "../../../store/user/selectors";
import whatsappIcon from "../../../assets/icons/whatsapp-icon.svg";
import gmailIcon from "../../../assets/icons/gmail-icon.svg";
import telegramIcon from "../../../assets/icons/telegram-icon.svg";

const { Title, Paragraph, Text } = Typography;

interface ReferAndEarnInterface {
  visible: boolean;
  onClose: () => void;
}

const ReferAndEarnModal: React.FC<ReferAndEarnInterface> = ({
  visible,
  onClose,
}) => {
  const user = useAppSelector(userSelectors.getUserDetails);
  const referralCode = user?.referral_code?.toLowerCase() ?? "-";
  const email_initials =
    user?.email?.split("@")[0].replace(/[^a-zA-Z0-9]/g, "-") ?? "-";

  const referralLink = `${window.location.origin}/signup?ref=${
    email_initials + "-" + referralCode
  }`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    notification.success({
      message: "Referral link copied!",
      description: "Share it with your friends and earn HVT coins.",
    });
  };

  const shareLinks = {
    whatsapp: `https://wa.me/?text= Hi! I just joined the HaveTo platform. Join with me and earn 1 HVT token (worth $8 USD) as a bonus! Sign up here: ${encodeURIComponent(
      referralLink
    )}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(
      referralLink
    )}&text= Hi! I just joined the HaveTo platform. Join with me and earn 1 HVT token (worth $8 USD) as a bonus!`,
    gmail: `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
      "Join me on HaveTo and start earning rewards!"
    )}&body=${encodeURIComponent(
      `Hey! \n\n I just joined the HaveTo platform. Join with me and earn 1 HVT token (worth $8 USD) as a bonus! \n\nSign up using my referral link:\n${referralLink}\n\nLet’s earn together!`
    )}`,
  };

  const handleShare = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      title="🎉 Refer & Earn"
      visible={visible}
      centered
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Typography style={{ padding: "0 8px" }}>
        <Paragraph style={{ fontSize: 16, color: "#444" }}>
          <strong>Your network just became your net worth.</strong> <br />
          Share the benefits and earn rewards for each successful referral.
        </Paragraph>

        <Divider />

        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Paragraph>
            <Space wrap size={4}>
              <Text strong>🔗 Share your referral link:</Text>
              <span>Send it to friends, family, or anyone you know.</span>
            </Space>
          </Paragraph>
          <Paragraph>
            <Space wrap size={4}>
              <Text strong>🎁 They earn a bonus:</Text> New users sign-ups with
              your link get a reward.
            </Space>
          </Paragraph>
          <Paragraph>
            <Space wrap size={4}>
              <Text strong>💸 You earn too:</Text> Each successful signup earns
              you real rewards.
            </Space>
          </Paragraph>
        </Space>
        <Row justify="space-between" gutter={12} style={{ marginBottom: 24 }}>
          <Col span={24} style={{ textAlign: "center" }}>
            <Space direction="horizontal" size={30}>
              <Image
                src={whatsappIcon}
                preview={false}
                style={{ cursor: "pointer" }}
                onClick={() => handleShare(shareLinks.whatsapp)}
              />
              <Image
                src={telegramIcon}
                preview={false}
                style={{ cursor: "pointer" }}
                onClick={() => handleShare(shareLinks.telegram)}
              />
              <Image
                src={gmailIcon}
                preview={false}
                style={{ cursor: "pointer" }}
                onClick={() => handleShare(shareLinks.gmail)}
              />
            </Space>
          </Col>
          <Col span={24}>
            <Text style={{ flex: 1 }}>Referral Link:</Text>
            <div className="refer-link-container">
              <Input
                className="change-password-input"
                readOnly
                value={referralLink}
              ></Input>
              <Button
                className="copy-btn"
                block
                icon={<CopyOutlined />}
                onClick={copyToClipboard}
              >
                Copy
              </Button>
            </div>
          </Col>
        </Row>
      </Typography>
    </Modal>
  );
};

export default ReferAndEarnModal;
